import { Game } from '../api/games';
import { filter, pipe, slice, sort } from 'ramda';

export function getGamePath(title: string) {
  return title
    .toLowerCase()
    .replace(/\s|&/g, '-')
    .replace(/[^\w\s&-]/g, '')
    .replace(/-{2,}/g, '-')
    .trim();
}

const filterByCategory = ({ categoryId }: { categoryId: string }) => ({
  listCollections,
}: Game) => listCollections.includes(categoryId);

const filterByProvider = ({ providerId }: { providerId?: string }) => ({
  provider,
}: Game) => {
  if (providerId == null) return true;

  return provider === providerId;
};

const sortByCategoryOrder = ({ categoryId }: { categoryId: string }) => (
  aGame: Game,
  bGame: Game
) => aGame.collections[categoryId] - bGame.collections[categoryId];

type GamesFilterParams = {
  categoryId?: string;
  providerId?: string;
  limit?: number;
};

export const gamesFilter = ({
  categoryId = 'all',
  providerId,
  limit = Infinity,
}: GamesFilterParams) =>
  pipe<any, Game[], Game[], Game[], Game[]>(
    filter(filterByCategory({ categoryId })),
    filter(filterByProvider({ providerId })),
    sort(sortByCategoryOrder({ categoryId })),
    slice(0, limit)
  );
